import { PERMISSIONS } from "router/permissions";
import { CustomerView } from "../views/Customers/CustomerView";
import BackupTableIcon from "@material-ui/icons/TableChart";
import { CUSTOMERS_TYPES } from "redux/reducers/customers/customersTypes";
import { creditsUnlockTypes } from "redux/reducers/creditsUnlock/types";
import { CustomersTableBoundary } from "views/Customers/CustomersTableBoundary";
import { CreditsUnlockView } from "views/CreditsUnlock/CreditsUnlockView";
import { ErpEquivalenciesView } from "views/ErpEquivalencies/ErpEquivalenciesView";
import { erpEquivalenciesTypes } from "redux/reducers/erpEquivalencies/types";

const { CRM, CRM_UNLOCK_ACCOUNTS_SERVICE, CRM_EQUIVALENCE_ERP_GN4 } = PERMISSIONS;

const config = {
  reducer: "customersReducer",
  restoreKey: CUSTOMERS_TYPES.RESTORE_INITIAL,
};

const creditsUnlockConfig = {
  reducer: "creditUnlock",
  restoreKey: creditsUnlockTypes.RESTORE_INITIAL,
};

const erpEquivalenciesConfig = {
  reducer: "erpEquivalencies",
  restoreKey: erpEquivalenciesTypes.RESTORE_INITIAL,
};

export const crmRoutes = [
  {
    collapse: true,
    name: "CRM",
    icon: BackupTableIcon,
    state: "crmCollapse",
    inSidebar: true,
    isProtected: true,
    rule: CRM,
    views: [
      {
        path: "/crm_clientes",
        name: "Clientes",
        mini: "CLI",
        component: CustomersTableBoundary,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CRM,
        ...config,
      },
      {
        path: "/cliente/:id/:accountId/:code/:phone?/:address?",
        name: "Cliente",
        mini: "CLI",
        component: CustomerView,
        layout: "/admin",
        sublayout: "/cliente",
        inSidebar: false,
        isProtected: true,
        rule: CRM,
        ...config,
      },
      {
        path: "/desbloqueo_cuenta_credito",
        name: "Desbloqueo CxC",
        mini: "CLI",
        component: CreditsUnlockView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CRM_UNLOCK_ACCOUNTS_SERVICE,
        ...creditsUnlockConfig,
      },
      {
        path: "/erp-equivalencies",
        name: "Clientes de Crédito",
        mini: "ERP",
        component: ErpEquivalenciesView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: CRM_EQUIVALENCE_ERP_GN4,
        ...erpEquivalenciesConfig,
      },
    ],
  },
];
